import { WritableDraft } from "immer";
import compact from "lodash/compact";
import { FilterV2 } from "PFTypes/filters_v2";

import { emitFiltersUpdate } from "../events";
import { FiltersV2StoreType } from "../filters_v2_store.types";
import { resetScope, validateFiltersScopeLimit } from "./check_scope_limit";

export const validateAndEmitFiltersUpdate = (
  draftState: WritableDraft<FiltersV2StoreType>,
  updatedFilters: (FilterV2 | undefined)[]
) => {
  const updatedFiltersClean = compact(updatedFilters);

  if (updatedFiltersClean.length === 0) {
    return;
  }

  resetScope(draftState, updatedFiltersClean);
  validateFiltersScopeLimit(draftState);
  emitFiltersUpdate(draftState, updatedFiltersClean);
};
